import { ExperiencesRequest, ExperiencesResponse, IAddressResponse, ILegalEntity } from '@cemex-core/cmx-api';
import { IJobsiteBlockedRequest } from '@cemex-core/cmx-api/models/jobsite-blocked';
import { ShippingCondition } from '@cemex-core/cmx-api/models/shipping-conditions/shipping-condition';
import { Action } from '@ngrx/store';
import { ILocationConfigUnit } from '@ordersnproducts/modules/order-builder/modules/location-specification/models/location-config.interface';
import { IJobsiteSalesAreaResponse } from '@ordersnproducts/modules/order-builder/modules/location-specification/models/order-management/jobsite-sales-area.model';
import {
  IRequestJobsitesResponse,
  Jobsite,
} from '@ordersnproducts/modules/order-builder/modules/location-specification/models/order-management/jobsite.model';

export interface IGeoCoordinates {
  latitude: number;
  longitude: number;
}

export const LS_LOAD_INITIAL_STATE = '[Bulk CEM UL Modify - Jobsite] Load initial state';
export const LS_RESET = '[Bulk CEM UL Modify - Jobsite] Reset state';
export const LS_LOAD = '[Bulk CEM UL Modify - Jobsite] Load';
export const LS_LOAD_COMPLETE = '[Bulk CEM UL Modify - Jobsite] Load Complete';
export const LS_LOAD_FAIL = '[Bulk CEM UL Modify - Jobsite] Load Fail';
export const LS_JOBSITE_SET = '[Bulk CEM UL Modify - Jobsite] Set';
export const LS_SALES_AREA_LOAD = '[Bulk CEM UL Modify - salesAreas] Load';
export const LS_SALES_AREA_LOAD_COMPLETE = '[Bulk CEM UL Modify - salesAreas] Load Complete';
export const LS_LOAD_ADDRESS = '[Bulk CEM UL Modify - Address] Load Address';
export const LS_LOAD_ADDRESS_SUCCESS = '[Bulk CEM UL Modify - Address] Load success Address';
export const LS_LOAD_ADDRESS_FAIL = '[Bulk CEM UL Modify - Address] Load fail Address';
export const LS_JOBSITE_MODAL = '[Bulk CEM UL Modify - Jobsite] Open jobsite change modal';
export const LS_LOAD_EXPERIENCE = '[Bulk CEM UL Modify - Experience] Load Experience';
export const LS_LOAD_EXPERIENCE_SUCCESS = '[Bulk CEM UL Modify - Experience] Load success Experience';
export const LS_LOAD_EXPERIENCES_FAIL = '[Bulk CEM UL Modify - Experience] Load fail Experience';
export const LS_LOAD_PURCHASE_ORDER_MASK_PATTERNS =
  '[Bulk CEM UL Modify - Experience] Load Purchase Order Mask Patterns';
export const LS_LOAD_PURCHASE_ORDER_MASK_PATTERNS_SUCCESS =
  '[Bulk CEM UL Modify - Experience] Load success Purchase Order Mask Patterns';
export const LS_LOAD_PURCHASE_ORDER_MASK_PATTERNS_FAIL =
  '[Bulk CEM UL Modify - Experience] Load fail Purchase Order Mask Patterns';

export class LoadJobsiteExperience {
  readonly type = LS_LOAD_EXPERIENCE;
  constructor(public payload: ExperiencesRequest) {}
}

export class LoadJobsiteExperienceComplete {
  readonly type = LS_LOAD_EXPERIENCE_SUCCESS;

  constructor(public payload: ExperiencesResponse) {}
}

export class LoadJobsiteExperienceFail {
  readonly type = LS_LOAD_EXPERIENCES_FAIL;

  // todo:: type of error handling
  constructor(public payload: any) {}
}

export class LoadJobsiteAddress {
  readonly type = LS_LOAD_ADDRESS;
  constructor(public payload: number) {}
}

export class LoadJobsiteAddressComplete {
  readonly type = LS_LOAD_ADDRESS_SUCCESS;

  constructor(public payload: IAddressResponse) {}
}

export class LoadJobsiteAddressFail {
  readonly type = LS_LOAD_ADDRESS_FAIL;

  // todo:: type of error handling
  constructor(public payload: any) {}
}

export class JobsiteLoadInitialStateAction implements Action {
  readonly type = LS_LOAD_INITIAL_STATE;

  constructor(public payload: ILocationConfigUnit) {}
}

export class JobsiteResetStateAction implements Action {
  readonly type = LS_RESET;

  constructor(public payload = null) {}
}

export class JobsiteLoadAction implements Action {
  readonly type = LS_LOAD;

  constructor(
    public payload: {
      jobsiteBlockedRequest: IJobsiteBlockedRequest;
      selectedJobsiteId: number;
      legalEntity: ILegalEntity;
      shipingCondition?: ShippingCondition;
    },
  ) {}
}

export class JobsiteLoadCompleteAction implements Action {
  readonly type = LS_LOAD_COMPLETE;

  constructor(public payload: IRequestJobsitesResponse) {}
}

export class JobsiteLoadFailAction implements Action {
  readonly type = LS_LOAD_FAIL;

  // todo:: type of error handling
  constructor(public payload: any) {}
}

export class JobsiteSetAction implements Action {
  readonly type = LS_JOBSITE_SET;

  constructor(public payload: Jobsite) {}
}

export class SalesAreaLoadAction implements Action {
  readonly type = LS_SALES_AREA_LOAD;

  constructor(
    public payload: {
      productlineId: number | string;
      shipmentlocationId: number | string;
      shippingConditionId: number | string;
    },
  ) {}
}

export class SalesAreaLoadCompleteAction implements Action {
  readonly type = LS_SALES_AREA_LOAD_COMPLETE;

  constructor(
    public payload: {
      salesAreas: IJobsiteSalesAreaResponse;
    },
  ) {}
}

export class JobsiteOpenModalAction implements Action {
  readonly type = LS_JOBSITE_MODAL;
  constructor(public payload: { openModal: boolean }) {}
}

export class PurchaseOrderMaskPatterLoadAction implements Action {
  readonly type = LS_LOAD_PURCHASE_ORDER_MASK_PATTERNS;
  constructor(public payload: { jobsiteId: number; productLine: string }) {}
}

export class PurchaseOrderMaskPatterLoadCompleteAction implements Action {
  readonly type = LS_LOAD_PURCHASE_ORDER_MASK_PATTERNS_SUCCESS;
  constructor(public payload: { purchaseOrderMaskPatterns: string[] }) {}
}

export class PurchaseOrderMaskPatterLoadFailAction implements Action {
  readonly type = LS_LOAD_PURCHASE_ORDER_MASK_PATTERNS_FAIL;
  constructor() {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type JobsiteActions =
  | JobsiteLoadAction
  | JobsiteLoadInitialStateAction
  | JobsiteResetStateAction
  | JobsiteLoadFailAction
  | JobsiteLoadCompleteAction
  | JobsiteSetAction
  | SalesAreaLoadCompleteAction
  | SalesAreaLoadAction
  | LoadJobsiteAddress
  | LoadJobsiteAddressComplete
  | LoadJobsiteAddressFail
  | JobsiteOpenModalAction
  | LoadJobsiteExperience
  | LoadJobsiteExperienceComplete
  | PurchaseOrderMaskPatterLoadAction
  | PurchaseOrderMaskPatterLoadCompleteAction
  | PurchaseOrderMaskPatterLoadFailAction;
